__webpack_require__.p = "/journee-portes-ouvertes-bachelor/fr/";